import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Button, Row, Col, ProgressBar, Card } from "react-bootstrap";
import swal from "sweetalert";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import loaderGif from "../Images/aiload.gif";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../Context/GlobalState";
import {
  FaCheck,
  FaCheckCircle,
  FaRegEye,
  FaRegEyeSlash,
} from "react-icons/fa";

import logo from "../Images/logo.svg";
import { Link } from "react-router-dom";
import key1 from "../Images/key1.svg";
import key2 from "../Images/web/key2.svg";
import key3 from "../Images/web/key3.svg";
import key4 from "../Images/web/key4.svg";
import key5 from "../Images/web/key5.svg";
import key6 from "../Images/web/cardimg5.svg";
import core1 from "../Images/web/core1.png";
import core2 from "../Images/web/core2.png";
import core3 from "../Images/web/core3.png";
import core4 from "../Images/web/core4.png";
import core5 from "../Images/web/core5.png";
import core6 from "../Images/web/core6.png";
import F1 from "../Images/web/Backlinks.png";
import F2 from "../Images/web/Google Analytics.png";
import F3 from "../Images/web/Google Search Console.png";
import F4 from "../Images/web/Local Business.png";
import F5 from "../Images/web/Social Media Optimization.png";
import F6 from "../Images/web/Structured Data.png";
import F7 from "../Images/web/AI Content Generator (2).png";
import LogoSlider from "./logopartner";
import { basicauth } from "../Utils/Credentials";
const Newregister = () => {
  const registerRef = useRef(null);

  return (
    <div className="">
      <div
        className="row pt-3 pb-5 m-0"
        style={{
          background:
            "linear-gradient(to right, #799EFF 0%, #A3BFFF 35%, #C7D9FF 65%, #E6F0FF 85%, #FFFFFF 100%)",
        }}
      >
        <div className="col-12 text-center mb-4">
          <h2
            style={{
              fontWeight: "600",
              fontSize: "2.2rem",
              lineHeight: "1.6",
              color: "#1a1a1a",
              letterSpacing: "1px",
            }}
          >
            Improve online visibility with our{" "}
            <span
              style={{
                borderBottom: "4px solid #007CF0",
                paddingBottom: "4px",
              }}
            >
              smart SEO tool
            </span>
          </h2>
        </div>

        <div className="col-md-6 pb-5 text-white d-flex align-items-center justify-content-center">
          <AnimatedCardList />
        </div>

        <div
          className="col-md-6 pb-5 d-flex align-items-center justify-content-center"
          ref={registerRef}
        >
          <div className="col-10 pb-5">
            <div className="auth-form-transparent text-left p-3">
              <Register />
            </div>
          </div>
        </div>
      </div>

      <More
        scrollToRegister={() =>
          registerRef.current.scrollIntoView({ behavior: "smooth" })
        }
      />
      <LogoSlider />
      <Slider
        scrollToRegister={() =>
          registerRef.current.scrollIntoView({ behavior: "smooth" })
        }
      />
    </div>
  );
};
const cardData = [
  {
    keyImg: key1,
    coreImg: core5,
    title: "Integrated Search Console, Google Trends and Google Analytics",
    desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
  },
  {
    keyImg: key2,
    coreImg: core4,
    title: "Search Engine Optimization",
    desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
  },
  {
    keyImg: key3,
    coreImg: core2,
    title: "Social Media Optimization",
    desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
  },
  {
    keyImg: key4,
    coreImg: core1,
    title: "Competitive Research Overview",
    desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
  },
  {
    keyImg: key5,
    coreImg: core3,
    title: "Structure Data",
    desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
  },
  {
    keyImg: key6,
    coreImg: core6,
    title: "Keyword Research",
    desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
  },
];
const More = ({ scrollToRegister }) => {
  return (
    <div
      className="row d-flex justify-content-center"
      style={{ background: "#E8F9FF" }}
    >
      <Col md={10}>
        <h1
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "2.5rem",
          }}
          className="mt-2 mb-3 text-center"
        >
          <b>Plans & Pricing</b>
        </h1>
        <div className="text-center my-3">
          <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
            🚀 Improve Your Rankings —{" "}
            <span style={{ color: "#FC4100" }}>Try Our Service Free for 3 Months!</span>, Limited
            Time Only!
          </h4>
          <Link style={{ textDecoration: "none" }}>
            <span
              style={{
                color: "#fff",
                fontWeight: 500,
                cursor: "pointer",
                padding: "7px 12px",
                border: "1px solid #007bff",
                backgroundColor: "#007bff",
                borderRadius: "6px",
                fontSize: ".9rem",
                textDecoration: "none",
              }}
              onClick={scrollToRegister}
            >
              Get Started For Free
            </span>
          </Link>
        </div>
        <Pricingcard scrollToRegister={scrollToRegister} />
      </Col>
    </div>
  );
};
const Slider = ({ scrollToRegister }) => {
  const cardData = [
    {
      id: 1,
      title: "Backlinks",
      desc: [
        "Show search engines your content is trustworthy.",
        "Boost rankings in search results.",
        "Bring traffic from reputable sources.",
        "Strengthen SEO and domain authority.",
      ],
      img: F1,
    },
    {
      id: 2,
      title: "Google Analytics",
      desc: [
        "Track traffic, bounce rates, and session time.",
        "See how visitors find and use your site.",
        "Guide data-driven business decisions.",
        "Improve marketing and user experience.",
      ],
      img: F2,
    },
    {
      id: 3,
      title: "Google Search Console",
      desc: [
        "Track clicks, impressions, and keyword rankings.",
        "Fix indexing issues for better visibility.",
        "Submit sitemaps and monitor mobile usability.",
        "Free tool to boost search presence.",
      ],
      img: F3,
    },
    {
      id: 4,
      title: "Local Business",
      desc: [
        "Create jobs and support the local economy.",
        "Offer unique, personalized services.",
        "Build strong customer relationships.",
        "Promote sustainability and community bonds.",
      ],
      img: F4,
    },
    {
      id: 5,
      title: "Social Media Optimization",
      desc: [
        "Increase visibility and brand awareness.",
        "Optimize content and hashtag strategy.",
        "Drive traffic from social platforms.",
        "Support digital marketing efforts.",
      ],
      img: F5,
    },
    {
      id: 6,
      title: "Structure Data",
      desc: [
        "Help search engines understand your content.",
        "Enable rich snippets and enhanced results.",
        "Improve CTR and search appearance.",
        "Boost SEO with schema markup.",
      ],
      img: F6,
    },
    {
      id: 7,
      title: "AI",
      desc: [
        "Generates content like blogs, product descriptions, and social posts using AI.",
        "Speeds up creation, saving time and effort.",
        "Ensures consistent tone and high quality.",
        "Scales content production efficiently.",
      ],
      img: F7,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(1);
  const CARD_WIDTH = 400;
  const GAP = 55;
  const VISIBLE_CARDS = 3;

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % cardData.length);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + cardData.length) % cardData.length);
  };

  const handleTabClick = (index) => {
    setActiveIndex(index);
  };

  const navBtnStyle = {
    background: "white",
    border: "1px solid #ccc",
    fontSize: "24px",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    cursor: "pointer",
  };

  const getTranslateX = () => {
    const centerOffset = Math.floor(VISIBLE_CARDS / 2);
    const maxIndex = cardData.length - 1;

    // Clamp the scroll when near the start or end
    let adjustedIndex = activeIndex;

    if (activeIndex < centerOffset) {
      adjustedIndex = centerOffset;
    } else if (activeIndex > maxIndex - centerOffset) {
      adjustedIndex = maxIndex - centerOffset;
    }

    // Prevent invalid range
    adjustedIndex = Math.max(
      centerOffset,
      Math.min(adjustedIndex, maxIndex - centerOffset)
    );

    return -(adjustedIndex - centerOffset) * (CARD_WIDTH + GAP);
  };

  return (
    <div
      className="p-5"
      style={{
        background: "#00013f",
        padding: "40px 20px",
        color: "#fff",
        overflow: "hidden",
      }}
    >
      {/* Tabs */}
      <div className="row justify-content-center mb-5 mt-5">
        <div
          className="d-flex flex-wrap justify-content-center"
          style={{ width: "80%", gap: "10px" }}
        >
          {cardData.map((card, index) => (
            <button
              key={card.id}
              onClick={() => handleTabClick(index)}
              style={{
                // padding: "10px 18px",
                borderRadius: "20px",
                border:
                  index === activeIndex ? "2px solid #fff" : "1px solid #999",
                backgroundColor: index === activeIndex ? "#fff" : "#6A5ACD",
                color: index === activeIndex ? "#4B0082" : "#fff",
                fontWeight: index === activeIndex ? "bold" : "normal",
                cursor: "pointer",
                width: "10rem",
              }}
            >
              {card.title}
            </button>
          ))}
        </div>
      </div>

      <div
        className="row justify-content-center align-items-center position-relative mb-5"
        style={{ overflow: "visible" }}
      >
        <div className="col-auto">
          <button onClick={handlePrev} style={navBtnStyle}>
            ‹
          </button>
        </div>

        <div
          className="col-10"
          style={{
            overflow: "visible",
            width: `${
              CARD_WIDTH * VISIBLE_CARDS + GAP * (VISIBLE_CARDS - 1)
            }px`,
          }}
        >
          <div
            style={{
              display: "flex",
              transition: "transform 0.4s ease, opacity 0.4s ease",

              transform: `translateX(${getTranslateX()}px)`,
              gap: `${GAP}px`,
            }}
          >
            {cardData.map((card, index) => {
              const isActive = index === activeIndex;
              const scale = isActive ? 1.1 : 1;
              const opacity = isActive ? 1 : 0.7;

              return (
                <div
                  key={card.id}
                  style={{
                    background: "#fff",
                    color: "#000",
                    borderRadius: "2rem",
                    padding: "10px",
                    width: `${CARD_WIDTH}px`,
                    textAlign: "center",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                    transform: `scale(${scale})`,
                    opacity,
                    transition: "transform 0.4s ease, opacity 0.4s ease",
                    flexShrink: 0,
                  }}
                >
                  <h5 style={{ marginBottom: "10px" }}>{card.title}</h5>
                  <img
                    src={card.img}
                    alt={card.title}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: "8px",
                      marginBottom: "12px",
                      maxHeight: "200px",
                    }}
                  />

                  <ul
                    style={{
                      textAlign: "left",
                      paddingLeft: "20px",
                      fontSize: "14px",
                    }}
                  >
                    {Array.isArray(card.desc) ? (
                      card.desc.map((point, i) => <li key={i}>{point}</li>)
                    ) : (
                      <li>{card.desc}</li>
                    )}
                  </ul>

                  {isActive && (
                    <button
                      style={{
                        marginTop: "15px",
                        backgroundColor: "#ff5722",
                        border: "none",
                        padding: "10px 20px",
                        color: "#fff",
                        borderRadius: "25px",
                        cursor: "pointer",
                      }}
                      onClick={scrollToRegister}
                    >
                      Try for free
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="col-auto">
          <button onClick={handleNext} style={navBtnStyle}>
            ›
          </button>
        </div>
      </div>
    </div>
  );
};
const AnimatedCardList = () => {
  const [visibleIndex, setVisibleIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleIndex((prevIndex) => (prevIndex + 1) % cardData.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center h-100">
      {cardData.map((card, index) => (
        <div
          key={index}
          className={`animated-card ${
            index === visibleIndex ? "show" : "hide"
          } mb-4`}
          style={{
            width: "90%",
            maxWidth: "600px",
            textAlign: "center",
            borderRadius: "20px",
            background: "rgba(255, 255, 255, 0.9)",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
            padding: "30px 20px",
            transition: "all 0.5s ease",
            backdropFilter: "blur(10px)",
          }}
        >
          {/* Icon */}
          <div className="mb-3">
            <img
              src={card.keyImg}
              alt={card.title}
              style={{
                height: "60px",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Title */}
          <h4
            style={{
              fontWeight: "700",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            {card.title}
          </h4>

          {/* Core Image */}
          <div className="mb-3">
            <img
              src={card.coreImg}
              alt={card.title}
              className="img-fluid"
              style={{
                maxHeight: "220px",
                borderRadius: "12px",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Description */}
          <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6" }}>
            {card.desc}
          </p>
        </div>
      ))}
    </div>
  );
};
const Register = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [siteMetrics, setSiteMetrics] = useState(null);
  const [formData, setFormData] = useState({
    sitename: "",
    site_url: "",
    site_category: "",
    full_name: "",
    mobile: "",
    email: "",
    website: "",
    company_name: "",
    password: "",
    confirmPassword: "",
    da: "",
    pa: "",
  });
  const [errors, setErrors] = useState({});
  const validateFields = () => {
    let newErrors = {};

    if (!formData.full_name.trim())
      newErrors.full_name = "Full Name is required";

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.website.trim()) newErrors.website = "Website is required";
    if (!formData.company_name.trim())
      newErrors.company_name = "Company Name is required";

    if (!formData.password.trim()) newErrors.password = "Password is required";
    else if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    if (!formData.confirmPassword.trim())
      newErrors.confirmPassword = "Please confirm your password";
    else if (formData.password !== formData.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";

    if (!formData.site_category)
      newErrors.site_category = "Site category is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newErrors = { ...errors };
    if (name.startsWith("comp_url")) {
      const index = parseInt(name.split("_")[2]);
      const newCompUrls = [...formData.comp_urls];
      newCompUrls[index] = value;
      setFormData({
        ...formData,
        comp_urls: newCompUrls,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });

      if (name === "password" && value.length < 6) {
        newErrors.password = "Password must be at least 6 characters long";
      } else {
        delete newErrors.password;
      }

      if (name === "confirmPassword") {
        if (value !== formData.password) {
          newErrors.confirmPassword = "Passwords do not match";
        } else {
          delete newErrors.confirmPassword;
        }
      }
    }
    if (errors[name]) {
      newErrors[name] = null;
    }
    setErrors(newErrors);
  };

  const handleSelectChange = (selectedOption) => {
    setFormData({
      ...formData,
      site_category: selectedOption,
    });

    if (errors.site_category) {
      setErrors({
        ...errors,
        site_category: null,
      });
    }
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const base64Credentials = btoa(`${username}:${password}`);

      const currentURL = window.location.href;
      const modeValue = currentURL.includes("plan=Standard")
        ? "Standard"
        : "7 Days";
      const removeTrailingSlash = (url) => (url ? url.replace(/\/$/, "") : "");

      const raw = JSON.stringify({
        userid: "0",
        site_url: removeTrailingSlash(formData.website),
        site_category: formData.site_category?.label,
        comp_url1: "",
        comp_url2: "",
        comp_url3: "",
        comp_url4: "",
        comp_url5: "",
        keywords: "string",
        project_name: formData.sitename,
        type: "1",
        full_name: formData.full_name,
        mobile: formData.mobile,
        email: formData.email,
        website: formData.website,
        company_name: formData.company_name,
        password: formData.password,
        da: "0",
        pa: "0",
        mode: modeValue,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const token = "0";
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Login/AddYourUrl?token=${token}`,
        requestOptions
      );
      const data = await res.json();

      if (data.result && data.result.length > 0) {
        const resultValue = data.result[0].result;
        const resultMessage = data.result[0].message || "";

        if (resultValue === "Y") {
          if (resultValue === "Y") {
            swal(
              "Registration Successful 🎉",
              "Your login credentials have been sent to your email.\nIf you did not receive them, please log in using your registered credentials.",
              "success"
            ).then(() => {
              window.location.href = "https://dashboard.seobix.com";
            });

            setFormData({
              site_url: "",
              site_category: "",
              comp_urls: ["", "", "", "", ""],
              sitename: "",
            });
          }

          setFormData({
            site_url: "",
            site_category: "",
            comp_urls: ["", "", "", "", ""],
            sitename: "",
          });
        } else if (resultValue === "N") {
          swal("Result", `❌ ${resultMessage}`, "warning");
        } else {
          swal("Info", "Unexpected result value", "info");
        }
      } else {
        swal("Error", data.msg || "Something went wrong!", "error");
      }

      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (error) {
      console.error("Error:", error);
      swal("Error", "Something went wrong!", "error");
      setLoading(false);
    }
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    const isValid = validateFields();
    if (isValid) {
      handleSubmit(e);
    } else {
      console.log("Validation failed");
    }
  };

  const [categories, setCategories] = useState([]);
  const fetchCategories = async () => {
    const base64Credentials = btoa(`${username}:${password}`);

    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Setting/GetBlogCategories`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );
      const data = await res.json();
      if (data.status === "0") {
        setCategories(
          data.data.map((category) => ({
            label: category.category_name,
            value: category.id,
          }))
        );
      } else {
        console.error("Failed to fetch categories:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);
  const formatDomainInput = (input) => {
    if (!input.startsWith("https://") && !input.startsWith("http://")) {
      return `https://${input}`;
    }
    return input;
  };
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const { password, username } = basicauth;
  const FetchSiteMetrics = async (type) => {
    setTransactionLoaderState(true);
    try {
      if (!formData.website.trim()) {
        swal("Error", "Please enter a website before fetching DA/PA.", "error");
        return;
      }

      const uuid = generateUUID();
      const formattedUrl = formatDomainInput(formData.website);
      const base64Credentials = btoa(`${username}:${password}`);

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchSiteMetrics`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: formattedUrl,
            scope: "domain",
            type: type,
          }),
        }
      );

      const data = await res.json();
      if (
        data.status === "0" &&
        data.msg === "Success" &&
        data.data.length > 0
      ) {
        const { da, pa } = data.data[0];
        setFormData((prevFormData) => ({
          ...prevFormData,
          da: da || "",
          pa: pa || "",
        }));

        setSiteMetrics(data.data[0]);
      } else {
        console.log("Site metrics not found in response");
      }
    } catch (error) {
      console.log("Error fetching site metrics:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img src={loaderGif} alt="Loading..." style={{ width: "100px" }} />
        </div>
      )}

      {/* <div
        className="card p-3 d-flex align-items-center mb-0 mt-4 mb-3 text-center"
        style={{
          background: "rgb(234, 229, 244)",
          color: "rgb(68, 23, 82)",
          fontSize: ".9rem",
        }}
      >
        Welcome! We're excited to have you here! Let's begin by filling out some
        essential details to set up your website profile. This process will help
        tailor insights and recommendations to improve your site's performance.
      </div> */}
      {/* <div className="row flex-grow justify-content-center  p-0" style={{alignItems:"center"}}>
        <div className=" col-9 mt-2" style={{}}> */}
      <div
        style={{
          background: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 12px 24px rgba(0, 0, 0, 0.08)",
          padding: "2rem",
          maxWidth: "700px",
          width: "100%",
          margin: "0 auto",
        }}
        className="auth-form-transparent text-left card"
      >
        {/* Logo */}
        <div className="d-flex justify-content-center mt-2 mb-3">
          <img src={logo} alt="Seobix" style={{ width: "8rem" }} />
        </div>

        {/* Title */}
        <h4 className="text-center text-primary fw-bold mb-4">
          Welcome to Seobix!
        </h4>

        {/* Field styling */}
        <style>{`
    .form-control {
      border-radius: 10px;
      border: 1px solid #ccc;
      font-size: 0.95rem;
      padding: 12px 14px;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .form-control:focus {
      border-color: #799EFF;
      box-shadow: 0 0 0 2px rgba(121, 158, 255, 0.2);
    }

    .form-control::placeholder {
      color: #aaa;
    }

    .invalid-feedback {
      font-size: 0.8rem;
      color: #dc3545;
    }

    .form-group {
      margin-bottom: 1rem;
    }

    .btn-primary {
      background-color: #799EFF;
      border: none;
      padding: 12px;
      font-weight: bold;
      border-radius: 10px;
    }

    .btn-primary:hover {
      background-color: #5e84e2;
    }
  `}</style>

        <Form onSubmit={onFormSubmit}>
          <Form.Group className="m-2 " controlId="formCompanyName">
            <Form.Control
              type="text"
              placeholder="Company Name e.g. Example Pvt Ltd"
              name="company_name"
              value={formData.company_name}
              onChange={handleChange}
              className={`${errors.company_name ? "is-invalid" : ""}`}
              style={{ padding: ".5rem" }}
            />
            {errors.company_name && (
              <div className="invalid-feedback">{errors.company_name}</div>
            )}
          </Form.Group>

          <Row className="px-0 m-2 mt-3">
            <Form.Group controlId="formName" className="col m-0 p-0">
              <Form.Control
                type="text"
                placeholder="Owner Name"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                style={{ padding: ".5rem" }}
                className={`${errors.full_name ? "is-invalid" : ""}`}
              />
              {errors.full_name && (
                <div className="invalid-feedback">{errors.full_name}</div>
              )}
            </Form.Group>

            <Form.Group controlId="formSiteName" className="col m-0 ps-2 p-0">
              <Form.Control
                type="text"
                name="sitename"
                value={formData.sitename}
                onChange={handleChange}
                placeholder="Enter Site Name"
                isInvalid={!!errors.sitename}
                style={{ padding: ".5rem" }}
              />
            </Form.Group>
          </Row>

          <Form.Group className="m-2 mt-3" controlId="formSiteCategory">
            <select
              value={formData.site_category}
              onChange={handleSelectChange}
              style={{
                borderRadius: "10px",
                border: "1px solid #ccc",
                boxShadow: "none",
                padding: "6px 8px",
                width: "100%",
              }}
            >
              <option value="" disabled>
                Select Site Category
              </option>
              {categories.map((category, index) => (
                <option key={index} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </Form.Group>

          <Row className="px-0 m-2 mt-3">
            <Form.Group controlId="formEmail" className="col m-0 p-0">
              <Form.Control
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={{ padding: ".5rem" }}
                className={`${errors.email ? "is-invalid" : ""}`}
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </Form.Group>

            <Form.Group controlId="formMobile" className="col m-0 ps-2 p-0">
              <Form.Control
                type="text"
                placeholder="Mobile"
                name="mobile"
                value={formData.mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setFormData({ ...formData, mobile: value });
                  }
                }}
                className={`${errors.mobile ? "is-invalid" : ""}`}
              />
              {errors.mobile && (
                <div className="invalid-feedback">{errors.mobile}</div>
              )}
            </Form.Group>
          </Row>

          <Form.Group
            className="m-2 mt-3"
            controlId="formPassword"
            style={{ position: "relative" }}
          >
            <Form.Control
              type={showPassword ? "text" : "password"}
              placeholder="Create Password"
              name="password"
              value={formData.password}
              style={{ padding: ".5rem" }}
              onChange={handleChange}
              className={`${errors.password ? "is-invalid" : ""}`}
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            >
              {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
            </span>
            {errors.password && (
              <div className="invalid-feedback">{errors.password}</div>
            )}
          </Form.Group>

          <Form.Group
            className="m-2"
            controlId="formConfirmPassword"
            style={{ position: "relative" }}
          >
            <Form.Control
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              name="confirmPassword"
              value={formData.confirmPassword}
              style={{ padding: ".5rem" }}
              onChange={handleChange}
              className={`${errors.confirmPassword ? "is-invalid" : ""}`}
            />
            <span
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            >
              {showConfirmPassword ? <FaRegEyeSlash /> : <FaRegEye />}
            </span>
            {errors.confirmPassword && (
              <div className="invalid-feedback">{errors.confirmPassword}</div>
            )}
          </Form.Group>

          <Row className="px-0 m-2 mt-3">
            <Form.Group controlId="formWebsite" className="col p-0 m-0">
              <Form.Control
                type="text"
                placeholder="Enter Your Website URL"
                name="website"
                value={formData.website}
                style={{ padding: ".5rem" }}
                onChange={handleChange}
                className={`${errors.website ? "is-invalid" : ""}`}
              />
              {errors.website && (
                <div className="invalid-feedback">{errors.website}</div>
              )}
            </Form.Group>

            {/* <Col
              md={3}
              className="d-flex align-items-center justify-content-end p-0 m-0"
            >
              <Link className="mt-1 mb-2" onClick={() => FetchSiteMetrics("1")}>
                Get DA/PA <FaCheckCircle />
              </Link>
            </Col> */}
          </Row>

          {/* <Row className="p-0 m-2 mt-3">
            <Form.Group controlId="formDA" className="col p-0 m-0">
              <Form.Control
                type="number"
                placeholder="DA"
                style={{ padding: ".5rem" }}
                name="da"
                value={formData.da}
                onChange={handleChange}
                className={`${errors.da ? "is-invalid" : ""}`}
              />
              {errors.da && <div className="invalid-feedback">{errors.da}</div>}
            </Form.Group>

            <Form.Group controlId="formPA" className="col  m-0">
              <Form.Control
                type="number"
                placeholder="PA"
                name="pa"
                style={{ padding: ".5rem" }}
                value={formData.pa}
                onChange={handleChange}
                className={`${errors.pa ? "is-invalid" : ""}`}
              />
              {errors.pa && <div className="invalid-feedback">{errors.pa}</div>}
            </Form.Group>
          </Row> */}

          <div className="d-flex justify-content-center my-4">
            <Button
              type="submit"
              className="btn-sm btn-primary"
              style={{ width: "25vw" }}
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>

      {/* </div>
      </div> */}
    </>
  );
};
const Pricingcard = ({ scrollToRegister }) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const GetPricingPlans = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Setting/GetPricingPlans`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SEO data.");
      }

      const data = await response.json();
      if (data.status === "0" && data.data) {
        const sortedPlans = [...data.data].sort((a, b) => {
           if (a.identity === "4") return -1;  // Free goes first
           if (b.identity === "4") return 1;
           return parseInt(a.identity) - parseInt(b.identity);
         });
       
         const formattedPlans = sortedPlans.map((plan) => ({
           name: plan.plan_name,
           price: plan.amount,
           duration: plan.duration,
           description: plan.desc1,
           features1: plan.features1,
           features2: plan.features2,
           features3: plan.features3,
           features4: plan.features4,
           heading: plan.heading,
           desc2: plan.desc2,
           features: plan.data.map((feature) => ({
             text: feature.description,
             video: feature.video_url || null,
           })),
           buttonText: "Start Now",
         }));
       
         setPlans(formattedPlans);
       }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    GetPricingPlans();
  }, []);
  return (
    <>
      {loading ? (
        <div className="text-center my-5">
          <img src={require("../Images/aiload.gif")} alt="seobix" />
        </div>
      ) : (
        <>
          <Row className="justify-content-center mx-1">
            {plans.map((plan, index) => (
              <Col key={index} md={6} lg={3} className="mb-4">
                <Card className="shadow-sm h-100">
                  <Card.Body className="p-3">
                    <h5 className="mb-1">
                      <b>{plan.name}</b>
                    </h5>
                    <h3>
                      <b>{plan.price}</b>/
                      <span style={{ fontSize: "1rem" }}>{plan.duration}</span>
                    </h3>{" "}
                    <Button 
                      className="mt-2 mb-2"
                      style={{ width: "100%" }}
                      onClick={scrollToRegister}
                    >
                      {plan.buttonText}
                    </Button>
                    <p className="text-muted mb-2 mt-3">
                      <b>{plan.description}</b>
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features1}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features2}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features3}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features4}
                    </p>
                    <h6>
                      <b>{plan.heading}</b>
                    </h6>
                    <p
                      className="text-muted mb-2 mt-3"
                      style={{ fontWeight: "500" }}
                    >
                      {plan.desc2}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </>
  );
};
export default Newregister;
